import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { fetchElectionComment } from "../../../api";
import styles from "./style.m.css";
import Icon from "../../atoms/icon";
import { Link } from "@quintype/components";
import { connect } from "react-redux";

const sign = require("jwt-encode");

const truncateContent = (content, maxLength) => {
  if (content.length <= maxLength) return content;
  return content.slice(0, maxLength) + "...";
};

const TnElectionCommentsWidget = props => {
  const [comments, setComments] = useState([]);

  const [visibleComments, setVisibleComments] = useState(5);
  const jwtKey = get(props, ["jwtKey"], "");

  function generateJWT(payload) {
    const secret = jwtKey;
    const jwt = sign(payload, secret);
    return jwt;
  }

  useEffect(() => {
    const PartyData = {
      _tn: Date.now()
    };

    fetchElectionComment(generateJWT(PartyData), "all")
      .then(res => {
        const comments = get(res, ["data", "items", "data"]);
        setComments(comments);
      })
      .catch(console.error);
  }, []);

  const loadMore = () => {
    setVisibleComments(prevVisibleComments => prevVisibleComments + 5); // Show next 5 comments
  };

  const toggleCommentExpansion = commentIndex => {
    setComments(prevComments =>
      prevComments.map(
        (comment, index) => (index === commentIndex ? { ...comment, expanded: !comment.expanded } : comment)
      )
    );
  };

  return (
    <div className={`${styles["election-container"]} container`}>
      {comments &&
        comments.length > 0 && (
          <div className={styles["comments-wrapper"]}>
            <div className={styles["comments-wrapper-section"]}>
              <h1 className={styles["comments-headline"]}>
                <span>வாசகர்களின் கருத்துகள்</span>
              </h1>
              <div className={styles["comments-height"]}>
                {comments.slice(0, visibleComments).map((comment, index) => (
                  <ul key={comment.id || index} className={styles["comments-section"]}>
                    <li className={styles["comments-header"]}>
                      <Icon type="icon-user" />
                      <div>
                        <h2>{get(comment, ["user_name"], "")}</h2>
                        <h3>
                          <Link
                            href={`/election/tn-assembly-election-2026/constituency/${get(
                              comment,
                              ["thokuthi_slug"],
                              ""
                            ).toLowerCase()}`}
                          >
                            {get(comment, ["area"], "")}
                          </Link>
                        </h3>
                      </div>
                    </li>
                    <li className={styles["comments-pblm"]}>
                      {comment && comment.expanded ? (
                        <div>
                          {get(comment, ["thokuthi_pblm"], "")}
                          <button onClick={() => toggleCommentExpansion(index)} className={styles["read-more-less"]}>
                            Read Less
                          </button>
                        </div>
                      ) : (
                        <div>
                          {truncateContent(get(comment, ["thokuthi_pblm"], ""), 200)}
                          {get(comment, ["thokuthi_pblm"], "").length > 200 && (
                            <button onClick={() => toggleCommentExpansion(index)} className={styles["read-more-less"]}>
                              Read More
                            </button>
                          )}
                        </div>
                      )}
                    </li>
                  </ul>
                ))}
              </div>
              {visibleComments < comments.length && (
                <div className={styles["load-more-wrapper"]}>
                  <button onClick={loadMore} className={styles["load-more"]}>
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
    </div>
  );
};

function mapStateToProps(state) {
  return { jwtKey: get(state, ["qt", "config", "JwtKey"]) };
}

export default connect(mapStateToProps)(TnElectionCommentsWidget);
